// import ' bfont-awesome/css/font-awesome.min.css';

export { RXBlock, RXBlockStatus, RXBlockColor } from "./RXBlock";
export { RXModal, RXModalColor, RXModalSize } from "./RXModal";
export { RXBadge } from "./RXBadge";
export { RXDialog } from "./RXDialog";
export { RXTableList } from "./RXTableList";
export { RXTableDetail } from "./RXTableDetail";

// export const RXBlock = _RXBlock
// export const RXBlockStatus = _RXBlockStatus
// export const RXBlockColor = _RXBlockColor

// export const RXBadge = _RXBadge
// export const RXDialog = _RXDialog
// export const RXTableList = _RXTableList
// export const RXTableDetail = _RXTableDetail

// module.exports = {
//     RXBlock: RXBlock,
//     RXBlockStatus: RXBlockStatus,
//     RXBlockColor: RXBlockColor,
//     RXBadge: RXBadge,
//     RXModalColor: RXModalColor,
//     RXModalSize: RXModalSize,
//     RXModal: RXModal,
//     RXDialog: RXDialog,
//     RXTableList: RXTableList,
//     RXTableDetail: RXTableDetail
// };